import Page from 'component/Page';
import { useEffect, useState, useMemo } from 'react';
import { sendPost, sendPut } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
import UserAppIdAdd from './UserAppIdAdd';
import UserUpdateAppId from './UserUpdateAppId';
import UserChangeAppIdPassword from './UserChangeAppIdPassword';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import { useCallback } from 'react';
import { formatDate, showConfirm, showToast } from 'util/utils';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

export const accountRoleNameMap = {
  0: string.ACCOUNT_ROLE_ADMIN,
  1: string.ACCOUNT_ROLE_PARENT,
  2: string.ACCOUNT_ROLE_CHILD,
};

export const accountStatusNameMap = {
  true: string.ACTIVE,
  false: string.INACTIVE,
};

const UserAppIds = ({ userId }) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const currentUser = useSelector(selectCurrentUser);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedUser, setSelectedUser] = useState(null);
  const [passwordUser, setPasswordUser] = useState(null);
  const [addUser, setAddUser] = useState(null);
  const history = useHistory();

  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [currentUser.isMonitorOnly]
  );

  //------------------------------FUNCTIONS----------------------------------------------------------
  const doSearch = useCallback(
    async (page, pageSize, getAll = false) => {
      let data = await sendPost({
        url: Urls.pocaccount.userlist,
        body: {
          id: userId,
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: '',
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setUsers(result);
        setTotal(total);
      }
      return result;
    },
    [currentUser]
  );
  useEffect(() => {
    doSearch(page, pageSize);
  }, [page, pageSize, doSearch]);
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key: raw.pocId,
        data: [
          raw.username,
          raw.displayName,
          raw.status === 1 ? '有効' : '無効',
          raw.status === 1 ? (
            <OverlayTrigger
              placement="top"
              overlay={
                raw.status === 1 && (
                  <Tooltip>{`${raw.username}の${string.POC_ACCOUNT_CH}一覧へ`}</Tooltip>
                )
              }
            >
              <Button
                style={{
                  padding: '3px',
                  minWidth: '4.5em',
                  display: 'flex',
                  justifyContent: 'center',
                }}
                id={raw.pocId}
                onClick={(e) => onUserClick(e)}
                // overlay={'Test'}
              >
                {/* <FaUserGroup /> */}
                <div>
                  <b>CH</b>
                </div>
              </Button>
            </OverlayTrigger>
          ) : null,
          formatDate(raw.registerDate, 'YYYY/MM/DD'),
        ],
        raw,
      })),
    []
  );
  const mainActions = isMonitorOnly
    ? []
    : [
        {
          icon: 'add',
          title: string.POC_ACCOUNT_CREATE_TITLE,
          onClick: () => setAddUser({ valid: true }),
        },
      ];
  const actions = isMonitorOnly
    ? []
    : [
        { render: 'edit', onClick: ({ raw }) => setSelectedUser(raw) },
        { render: 'password', onClick: ({ raw }) => setPasswordUser(raw) },
        // ({ raw }) => {
        // 	if (raw.status === 1) {
        // 		return {
        // 			render: 'channels',
        // 			onClick: ({ raw }) => history.push(`${Paths.pocaccount.detail}/?id=${raw.pocId}`)
        // 		};
        // 	}
        // },
        ({ raw }) => {
          // if (!isAdmin) {
          // 	return null;
          // }
          if (raw.status === 1) {
            return {
              render: 'ban',
              className: 'color-danger',
              onClick: ({ raw }) => {
                // console.log('Ban');
                let pocData = {
                  pocId: raw.pocId,
                  status: 0,
                  role: raw.role === 'premium' ? 1 : 0,
                };
                showConfirm({
                  body: string.POC_ACCOUNT_DELETE_CONFIRM,
                  defaultAction: () => {
                    sendPut({
                      url: Urls.pocaccount.status,
                      body: pocData,
                    })
                      .then((res) => {
                        showToast(string.POC_ACCOUNT_DELETE_SUCCESS, 'success');
                        doSearch(page, pageSize);
                      })
                      .catch((e) => {
                        console.log('削除エラー');
                      });
                  },
                });
              },
            };
          } else {
            return {
              render: 'approve',
              onClick: ({ raw }) => {
                // console.log('Approve');
                let pocData = {
                  pocId: raw.pocId,
                  status: 1,
                  role: raw.role === 'premium' ? 0 : 1,
                };
                showConfirm({
                  body: string.POC_ACCOUNT_APPROVE_CONFIRM,
                  defaultAction: () => {
                    sendPut({
                      url: Urls.pocaccount.status,
                      body: pocData,
                    })
                      .then((res) => {
                        showToast(
                          string.POC_ACCOUNT_APPROVE_SUCCESS,
                          'success'
                        );
                        doSearch(page, pageSize);
                      })
                      .catch((e) => {
                        console.log('承認エラー');
                      });
                  },
                });
              },
            };
          }
        },
      ];
  const onUserClick = (e) => {
    // console.log(e.currentTarget.id);
    let id = e.currentTarget.id;
    history.push(`${Paths.pocaccount.detail}/?id=${id}`);
  };

  //-------------------------------RETURN------------------------------------------------------------
  return (
    <>
      <Page
        // title={string.POC_ACCOUNT_MANAGEMENT}
        body={
          <>
            <Table
              className="nowrap"
              mainActions={mainActions}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={[
                string.POC_LOGIN_ID,
                string.POC_DISPLAY_NAME,
                string.POC_ACCOUNT_STATUS,
                string.POC_ACCOUNT_CH,
                string.POC_ACCOUNT_REGISTERED_DATE,
              ]}
              data={dataTable(users)}
              // getCSVData={async () => {
              //   return dataTable(await doSearch(1, total, true));
              // }}
              // csvFileName="AppUserList"
              isPaging={true}
              actions={actions}
            />
          </>
        }
      />
      <Modal
        show={!!selectedUser}
        onHide={() => setSelectedUser(null)}
        body={
          <>
            {!!selectedUser && (
              <UserUpdateAppId
                onUpdated={() => {
                  setSelectedUser(null);
                  doSearch(page, pageSize);
                }}
                data={selectedUser}
              />
            )}
          </>
        }
      />
      <Modal
        show={!!passwordUser}
        onHide={() => setPasswordUser(null)}
        body={
          <>
            {!!passwordUser && (
              <UserChangeAppIdPassword
                onUpdated={() => {
                  setPasswordUser(null);
                  doSearch(page, pageSize);
                }}
                data={passwordUser}
              />
            )}
          </>
        }
      />
      <Modal
        show={!!addUser}
        onHide={() => setAddUser(null)}
        body={
          <>
            {!!addUser && (
              <UserAppIdAdd
                onUpdated={() => {
                  setAddUser(null);
                  doSearch(page, pageSize);
                }}
                data={{ userId, addUser }}
              />
            )}
          </>
        }
      />
    </>
  );
};

export default UserAppIds;
